export const blockIconsAudioandvideoPlaylistAddCheck = (
	<span className='material-symbols-outlined'>playlist_add_check</span>
);
